// extracted by mini-css-extract-plugin
export default {"add":"control_add__Twijd"};